import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

// Deals already carry a real `conversation_id` (docs/deals-ui-integration.md)
// so, unlike the Leads page's goToLeadConversation, this never needs to
// guess one from a phone-number search — it's either on the deal record or
// it isn't linked to a conversation yet.
const CRM_BASE_URL = process.env.REACT_APP_BACKEND_URL || "https://api.crm.dalmlabs.com/api/v1";

export const goToDealConversation = async (
  navigate: ReturnType<typeof useNavigate>,
  conversationId: string | null | undefined,
  phone: string | null | undefined,
  title: string
) => {
  if (!conversationId) {
    toast.error("This deal isn't linked to a conversation yet.");
    return;
  }
  const token = localStorage.getItem("authToken");
  const target = { conversationId, phoneNumber: phone || "", title };

  try {
    const direct = await fetch(`${CRM_BASE_URL}/conversations/${encodeURIComponent(conversationId)}`, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    });
    if (direct.ok) {
      sessionStorage.setItem("pendingConversationTarget", JSON.stringify(target));
      navigate("/chats");
      return;
    }

    // Not found active — it may be archived under the same id.
    const unarchiveRes = await fetch(`${CRM_BASE_URL}/conversations/${encodeURIComponent(conversationId)}/unarchive`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    });
    if (unarchiveRes.ok) {
      sessionStorage.setItem("pendingConversationTarget", JSON.stringify(target));
      navigate("/chats");
      return;
    }

    toast.error("Couldn't open this conversation.");
  } catch {
    toast.error("Couldn't open this conversation.");
  }
};
